
    const data = {"name":"src/core/icons/greater-than","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m5.5 4.14-1 1.72L15 12 4.5 18.14l1 1.72L19 12 5.5 4.14Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            